import { render, staticRenderFns } from "./OtherItems.vue?vue&type=template&id=99c7c5e2"
import script from "./OtherItems.vue?vue&type=script&lang=js"
export * from "./OtherItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports